import {styled} from "@mui/material/styles"
import {
	mobileThreshold,
	portfolioWidth
} from "../../../../Constants/layoutValues";
import {cssVarColors} from "../../../../Constants";
import {SectionTitle} from "../../HomePageStyles";

export const ValuePropsSectionWrapper = styled('div')`
	padding-top: 2rem;
	padding-bottom: 1.5rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	@media (max-width: ${mobileThreshold}px)
	{
		padding-bottom: 0;
	};
`;

export const Wrapper = styled('div')`
	width: 100%;
	padding-left: 1rem;
	padding-right: 1rem;
	box-sizing: border-box; // ✅ includes padding in total width
`;

export const Title = SectionTitle;

export const ValuePropsWrapper = styled('div')`
	padding-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.2rem;
	@media (max-width: ${mobileThreshold}px)
	{
		padding-top: 3rem;
	};
`

export const InternalWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	@media (max-width: ${mobileThreshold}px) {
	}
`;
